import { useMemo } from 'react';

import { buildConciergeOverridesCss, conciergeThemeAttribute, ConciergeCustomizationSettings } from './concierge-theme';
import { useConciergeTheme } from './use-concierge-theme';

type ConciergeScopeProps = { className: string; 'data-concierge-theme'?: string };

/** Props that put an element and its subtree on the store's Concierge scheme. */
export function conciergeScopeProps(settings: ConciergeCustomizationSettings | null | undefined): ConciergeScopeProps {
  return { className: 'concierge-mode', 'data-concierge-theme': conciergeThemeAttribute(settings) ?? undefined };
}

/**
 * Themes a Concierge entry card from the store's Concierge theme (partner,
 * Admin, then stock). Render `<ConciergeVariables $tenantOverrides={overridesCss} />`
 * once and spread `scopeProps` on the card root so only the card's own `--dcm-*`
 * tokens are re-skinned.
 */
export function useConciergeThemeScope(): {
  overridesCss: string;
  scopeProps: ConciergeScopeProps;
} {
  const { settings } = useConciergeTheme();
  const overridesCss = useMemo(() => buildConciergeOverridesCss(settings), [settings]);

  return {
    overridesCss,
    scopeProps: conciergeScopeProps(settings),
  };
}
